module.exports = __webpack_public_path__ + "img/logo@3x.15693a9a.png";